module.exports = __webpack_public_path__ + "static/media/finChart.536ff8a5.png";